import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCart } from "../../../hooks/useCart";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { clearCart } = useCart();
  
  // Payment sayfasından gelen sipariş detayları
  const orderDetails = location.state?.orderDetails;
  
  useEffect(() => {
    // Sipariş detayları yoksa ana sayfaya yönlendir
    if (!orderDetails) {
      navigate("/");
      return;
    }
    
    // Sepeti temizle
    clearCart();
  }, [orderDetails, navigate, clearCart]);
  
  if (!orderDetails) {
    return null;
  }
  
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        {/* Başarı İkonu */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
            <svg
              className="w-10 h-10 text-green-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>
        
        {/* Başlık */}
        <h1 className="text-2xl font-bold text-center text-gray-900 mb-2">
          Ödeme Başarılı!
        </h1>
        <p className="text-center text-gray-600 mb-8">
          Siparişiniz başarıyla alındı.
        </p>
        
        {/* Sipariş Detayları */}
        <div className="bg-gray-50 rounded-lg p-6 space-y-4">
          <div className="flex justify-between items-center py-2 border-b border-gray-200">
            <span className="text-sm text-gray-600">Sipariş No:</span>
            <span className="text-sm font-medium text-gray-900">
              #{orderDetails.orderNo}
            </span>
          </div>
          
          <div className="flex justify-between items-center py-2 border-b border-gray-200">
            <span className="text-sm text-gray-600">Sipariş Tarihi:</span>
            <span className="text-sm font-medium text-gray-900">
              {new Date(orderDetails.orderDate).toLocaleDateString('tr-TR')}
            </span>
          </div>
          
          <div className="flex justify-between items-center py-2 border-b border-gray-200">
            <span className="text-sm text-gray-600">Ödeme Tipi:</span>
            <span className="text-sm font-medium text-gray-900">
              {orderDetails.paymentType}
            </span>
          </div>
          
          <div className="flex justify-between items-center py-2 border-b border-gray-200">
            <span className="text-sm text-gray-600">Satıcı:</span>
            <span className="text-sm font-medium text-gray-900">
              {orderDetails.dealerName}
            </span>
          </div>
          
          <div className="flex justify-between items-center py-2 border-b border-gray-200">
            <span className="text-sm text-gray-600">Tahmini Teslim:</span>
            <span className="text-sm font-medium text-gray-900">
              {orderDetails.estimatedDelivery}
            </span>
          </div>
          
          <div className="flex justify-between items-center py-2">
            <span className="text-base font-medium text-gray-900">Toplam Tutar:</span>
            <span className="text-lg font-bold text-[#4F46E5]">
              {orderDetails.amount} TL
            </span>
          </div>
        </div>
        
        {/* Bilgi Mesajı */}
        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <p className="text-sm text-blue-800">
            Sipariş detaylarınız e-posta adresinize gönderilmiştir. 
            Siparişlerim sayfasından sipariş durumunuzu takip edebilirsiniz.
          </p>
        </div>
        
        {/* Butonlar */}
        <div className="mt-8 space-y-3">
          <button
            onClick={() => navigate("/siparislerim")}
            className="w-full bg-[#4F46E5] text-white py-3 rounded-lg hover:bg-[#4338CA] transition-colors font-medium"
          >
            Siparişlerim
          </button>
          <button
            onClick={() => navigate("/")}
            className="w-full bg-white text-gray-700 py-3 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors font-medium"
          >
            Anasayfaya Dön
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;